import { safeSessionStorage } from './ssr-helper';
import { SESSION_STORAGE_KEYS } from '../constants';

const STORAGE_KEY = SESSION_STORAGE_KEYS.SEARCH_PARAMETERS;

export const saveSearchParameters = (params = {}) => {
  try {
    const timestamp = new Date().getTime();
    
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== null && value !== undefined)
    );
    
    const storageData = {
      ...filteredParams,
      timestamp,
    };
    return safeSessionStorage.setItem(STORAGE_KEY, JSON.stringify(storageData));
  } catch (error) {
    console.error('[searchParametersStorage] Error saving parameters:', error);
    return false;
  }
};

export const getSearchParameters = () => {
  try {
    const stored = safeSessionStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }
    return JSON.parse(stored);
  } catch (error) {
    console.error('[searchParametersStorage] Error retrieving parameters:', error);
    return null;
  }
};

export const clearSearchParameters = () => {
  try {
    return safeSessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('[searchParametersStorage] Error clearing parameters:', error);
    return false;
  }
};

export const buildSearchParametersFromUrl = (searchString) => {
  if (!searchString) {
    return {};
  }

  const searchParams = new URLSearchParams(searchString);
  const params = {};

  for (const [key, value] of searchParams.entries()) {
    params[key] = isNaN(value) ? value : Number(value);
  }

  return params;
};

export const extractRelevantSearchParams = (
  searchString = '',
  packageData = {},
  salidaId = null,
  isInternal = false
) => {
  const urlParams = buildSearchParametersFromUrl(searchString);

  return {
    monthYear: urlParams.monthYear || null,
    dateSince: urlParams.dateSince || null,
    dateUntil: urlParams.dateUntil || null,
    adultsQty: urlParams.adultsQty || null,
    originId: urlParams.originId || null,
    originName: urlParams.originName || null,
    destinationId: urlParams.destinationId || null,
    destinationName: urlParams.destinationName || null,
    packageId: packageData?.id || packageData?.externalId || null,
    packageType: isInternal ? 'internal' : 'external',
    salidaId: salidaId || null,
    price: packageData?.price || null,
    currencyCode: packageData?.currencyCode || null,
  };
};

export const mergeSearchParametersWithStored = (
  searchString = '',
  packageData = {},
  salidaId = null,
  isInternal = false
) => {
  const newParams = extractRelevantSearchParams(
    searchString,
    packageData,
    salidaId,
    isInternal
  );

  const storedParams = getSearchParameters();

  const merged = {
    ...storedParams,
    ...newParams,
    originId: newParams.originId || storedParams?.originId,
    originName: newParams.originName || storedParams?.originName,
    destinationId: newParams.destinationId || storedParams?.destinationId,
    destinationName: newParams.destinationName || storedParams?.destinationName,
    timestamp: new Date().getTime(),
  };

  return Object.fromEntries(
    Object.entries(merged).filter(([_, value]) => value !== null && value !== undefined)
  );
};
